import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    List,
    ListItem,
    ListItemText,
    Typography,
} from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import { Link } from 'react-router-dom';

const Paylocity = () => {
    const listItemStyles = {
        display: 'list-item',
        paddingTop: '0',
        paddingBottom: '0',
    };
    return (
        <Box p={2}>
            <Typography variant='h4' align='center'>
                Paylocity FAQ
            </Typography>
            <Box pt='20px'>
                <Typography>Looking for non Paylocity related questions?  Check out our <Link to='/faq'>FAQ page</Link></Typography>
            </Box>
            <Box maxWidth='700px' m='20px auto 0 auto'>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                        <Typography style={{ fontWeight: 'bold' }}>
                            What is Paylocity?
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography variant='body2'>
                            An explanation of Paylocity can be found in <a href={
                                    process.env.PUBLIC_URL +
                                    '/files/Login_to_Paylocity.pdf'
                                } target='_blank'>this guide</a>
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                        <Typography style={{ fontWeight: 'bold' }}>
                            Can I put Paylocity on my phone?
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box>
                            <Typography variant='body2'>A walkthrough video can be found <a href="https://learning.paylocity.com/videos/external/view/PZsrDSPpPQk5" target="_blank">here</a></Typography>
                            <Box pl={4}>
                                <List
                                    style={{ listStyleType: 'circle' }}
                                    disablePadding={true}
                                    dense={true}
                                >
                                    <ListItem style={listItemStyles}>
                                        <ListItemText>
                                            Download the applicable version of the
                                            App:
                                        </ListItemText>
                                        <List
                                            disablePadding={true}
                                            dense={true}
                                            style={{ listStyleType: 'disc' }}
                                        >
                                            <ListItem style={listItemStyles}>
                                                <ListItemText>
                                                    <a href='https://play.google.com/store/apps/details?id=com.paylocity.paylocitymobile' target='_blank'>Google Android version</a> is available for download and install on all Android OS 8 or higher devices.
                                                </ListItemText>
                                            </ListItem>
                                            <ListItem style={listItemStyles}>
                                                <ListItemText>
                                                    <a href='https://itunes.apple.com/us/app/paylocity-mobile/id652438572?mt=8' target='_blank'>Apple iOS version</a> is available for download and install on Apple iOS 11 or higher devices (iPhone, iPad, and iPod Touch).
                                                </ListItemText>
                                            </ListItem>
                                            <ListItem style={listItemStyles}>
                                                <ListItemText>
                                                    Requirements are subject to change.
                                                </ListItemText>
                                            </ListItem>
                                        </List>
                                    </ListItem>
                                    <ListItem style={listItemStyles}>
                                        <ListItemText>
                                            Register a new user account on the Paylocity Mobile App.
                                        </ListItemText>
                                    </ListItem>
                                    <ListItem style={listItemStyles}>
                                        <ListItemText>
                                            Log In to access the app.
                                        </ListItemText>
                                    </ListItem>
                                    <ListItem>
                                        <ListItemText>

                                        </ListItemText>
                                    </ListItem>
                                </List>
                            </Box>
                            <Typography variant='body2'>There is a Spanish version of this document available <a href='https://docs.paylocity.com/knowledge/Spanish/PCTY-54144ClientEmployee.pdf' target='_blank'>here</a></Typography>
                        </Box>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                        <Typography style={{ fontWeight: 'bold' }}>
                            How do I get my pay stub?
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography variant='body2'>
                            Step by step instructions can be found{' '}
                            <a
                                href={
                                    process.env.PUBLIC_URL +
                                    '/files/How_to_Print_a_Paylocity_Paystub.pdf'
                                }
                                target='_blank'
                            >
                                in this guide
                            </a>
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                        <Typography style={{ fontWeight: 'bold' }}>
                            How do I get my W2?
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography variant='body2'>
                            Step by step instructions can be found{' '}
                            <a
                                href={
                                    process.env.PUBLIC_URL +
                                    '/files/How_to_Print_a_Paylocity_W-2.pdf'
                                }
                                target='_blank'
                            >
                                in this guide
                            </a>
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            </Box>
        </Box>
    );
};

export default Paylocity;
